"use client";

import React, { useEffect, useState, useRef } from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function CinematicVision() {
  const [offset, setOffset] = useState(0);
  const sectionRef = useRef<HTMLElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (sectionRef.current) {
        const rect = sectionRef.current.getBoundingClientRect();
        if (rect.top < window.innerHeight && rect.bottom > 0) {
          setOffset(window.scrollY);
        }
      }
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const strips = [{
    img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1621178/img/propvr_arch_1.png",
    speed: 0.15,
    mt: "0px"
  }, {
    img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1621178/img/propvr_arch_2.png",
    speed: -0.2,
    mt: "100px"
  }, {
    img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1621178/img/propvr_arch_3.png",
    speed: 0.1,
    mt: "0px"
  }, {
    img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1621178/img/propvr_arch_4.png",
    speed: -0.15,
    mt: "150px"
  }, {
    img: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1621178/img/propvr_arch_5.png",
    speed: 0.2,
    mt: "50px"
  }];
  return <section data-section-id="6929" id="future-of-reality-hero" ref={sectionRef} className="dark bg-background text-foreground relative min-h-screen w-full overflow-hidden flex items-center justify-center py-20">
      {}
      <div className="absolute inset-0 z-0 grid grid-cols-5 gap-2 md:gap-4 px-2 md:px-8 opacity-20 pointer-events-none select-none">
        {strips.map((strip, i) => <div key={i} data-index={i} className="relative w-full h-[150%] -top-[25%] overflow-hidden rounded-[12px]" style={{
        transform: `translateY(${offset * strip.speed}px)`,
        marginTop: strip.mt
      }}>
            <div className="absolute inset-0 bg-cover bg-center" style={{
          backgroundImage: `url(${strip.img})`
        }} />
            <div className="absolute inset-0 bg-[#0E0C15]/40" />
          </div>)}
      </div>

      {}
      <div className="absolute inset-0 z-10 bg-[radial-gradient(circle_at_center,transparent_10%,var(--background)_85%)] pointer-events-none" />

      {}
      <div className="relative z-20 container mx-auto px-4 flex flex-col items-center text-center">
        <h1 className="font-default text-5xl md:text-6xl lg:text-[60px] font-bold tracking-tighter uppercase mb-8 drop-shadow-md">
          <span className="bg-gradient-to-b from-white to-white/60 bg-clip-text text-transparent">
            Transforming Spatial
            <br />
            Intelligence
          </span>
        </h1>

        <p className="font-default text-lg md:text-xl text-muted-foreground max-w-[60ch] mb-12 leading-relaxed">
          PropVR crafts immersive digital twins and 3D architectural experiences
          that redefine property showcases through cutting-edge spatial
          technology.
        </p>

        <Button asChild size="lg" className="h-16 px-10 rounded-[10px] text-lg font-medium bg-primary text-primary-foreground hover:bg-primary/90 shadow-[0_0_30px_rgba(23,85,253,0.4)] transition-all duration-300 hover:scale-105">
          <Link to="#">
            Explore Platform
            <ArrowRight className="ml-2 w-5 h-5" />
          </Link>
        </Button>
      </div>
    </section>;
}